export default __webpack_public_path__ + "39175a101f1c1a1729ad2d9eab95793b.png";